module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.creationRequests,
      "pagination": _vm.pagination,
      "total-items": _vm.totalCreationRequests,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(ref) {
        var header = ref.header;

        return [_c('span', {
          staticClass: "body-2 font-weight-regular accent--text",
          domProps: {
            "textContent": _vm._s(header.text)
          }
        })]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.merchantId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.makerUsername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.makerComment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.requestType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdAt))]), _vm._v(" "), _c('td', [(props.item.approved === 1) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "primary"
          }
        }, [_vm._v(" APPROVED")]) : _vm._e(), _vm._v(" "), (props.item.approved === 0) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "secondary"
          }
        }, [_vm._v(" NOT YET APPROVED")]) : _vm._e(), _vm._v(" "), (props.item.approved === 2) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "warning"
          }
        }, [_vm._v(" REJECTED ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.checkerUsername))])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-453fd6c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/merchant/merchantrequests.vue
// module id = 1056
// module chunks = 2